// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__39d-X","related":"styles_related__3dzG8"};